import React from 'react';
import { observer } from 'mobx-react-lite';
import { rootStore } from '../../../mobx/rootStore';
import { MenuItem } from '../menuItem';

interface Props {
  isActive: boolean;
}

const NotificationBadge: React.FC<Props> = ({ isActive }) => {
  const { notificationStore } = rootStore;
  const { notifications } = notificationStore || {};
  const inboxCount = notifications?.filter((item) => !item?.isRead).length;

  return <MenuItem path='/' isActive={isActive} iconName='inbox-icon' label='Inbox' count={inboxCount} />;
};

export default observer(NotificationBadge);
